export default function AdministrationDashboard({ user }: any) {
  console.log(user);
  return (
    <div>hola</div>
  );
}